import React from 'react'
import useGetTeams from '@/services/api/team/useGetTeams'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/Select'
import { Star } from 'lucide-react'

interface SpaceSelectComponentProps {
  selectedTeamId: string | null
  onValueChange: (value: string) => void
  placeholder?: string
  className?: string
}

export default function SpaceSelectComponent({
  selectedTeamId,
  onValueChange,
  placeholder = "Choose a space to manage",
  className = "w-full"
}: SpaceSelectComponentProps) {
  const {
    data: teams,
    isLoading: teamsLoading,
  } = useGetTeams()

  return (
    <div>
      <label className="mb-2 block">Select Space</label>
      <Select value={selectedTeamId} onValueChange={onValueChange}>
        <SelectTrigger className={className}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {teamsLoading ? (
            <SelectItem value="loading" disabled>
              Loading spaces...
            </SelectItem>
          ) : (
            teams?.map((team) => (
              <SelectItem key={team.id} value={team.id}>
                <div className="flex w-full items-center justify-between">
                  <span>{team.name}</span>
                  {team.is_default && (
                    <Star className="ml-2 h-4 w-4 text-yellow-500" />
                  )}
                </div>
              </SelectItem>
            ))
          )}
        </SelectContent>
      </Select>
    </div>
  )
}